import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {DefaultProfile, PesDashboardConfig, PesDashboardConfigProvider} from '@pes/ui';
import {LbpaProfile} from './lbpa-profile.constant';
import {CIRCUIT_MANAGEMENT_DASHBOARD_CONFIG} from '../dashboard/circuit-management-dashboard.config';

/**
 * A service that provides dashboard configuration for the current user.
 */
@Injectable()
export class DashboardConfigProvider extends PesDashboardConfigProvider {

    /**
     * The dashboard config associated with the current user's profile.
     */
    protected config: PesDashboardConfig = null;

    /**
     * Creates a new CircuitStatusService instance.
     *
     * @param {Injector} injector the reference to the Angular injector.
     */
    constructor(protected injector: Injector) {
        super(injector);
    }

    /**
     * Returns the dashboard config for the current user.
     *
     * @return {Observable<PesDashboardConfig>} the the dashboard config for the current user.
     */
    public getConfig(): Observable<PesDashboardConfig> {
        return this.initConfig();
    }

    /**
     * Initializes and returns the dashboard config associated with the current user's profile.
     *
     * @returns {Observable<PesDashboardConfig>} the dashboard config associated with the current user's profile.
     */
    protected initConfig(): Observable<PesDashboardConfig> {
        if (!this.config && this.account.hasAnyProfile(LbpaProfile.CONSEILLER_ADMIN, DefaultProfile.CIRCUIT_MANAGER, DefaultProfile.DEVELOPER)) {
            this.config = CIRCUIT_MANAGEMENT_DASHBOARD_CONFIG;
        }
        return of(this.config);
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/dashboard-config.provider.ts